/**
 * PRIMEX — assets/primex-textile-cards.js (v1.0)
 *
 * Card/slider UI for Handelsware products that use custom.textile_slots.
 * It does not calculate prices. It controls the real #px-hw-modes buttons,
 * .px-hw-fabric selects, .px-hw-upinput file inputs, #px-hw-pd-select and
 * the per-slot hidden design-state inputs rendered by primex-configurator.liquid.
 * primex-configurator.js remains the only pricing and cart-property authority.
 */
(function () {
  'use strict';

  var root = document.getElementById('px-configurator');
  var wrap = document.getElementById('px-hw-textile');
  if (!root || !wrap || wrap.classList.contains('pxhw-enhanced')) return;

  var slots = Array.prototype.slice.call(wrap.querySelectorAll('.px-hw-slot'));
  var modeRow = document.getElementById('px-hw-modes');
  var modeButtons = modeRow ? Array.prototype.slice.call(modeRow.querySelectorAll('.px-exec-btn')) : [];
  if (!slots.length || modeButtons.length < 2) return;

  var en = (function () {
    try {
      var cfgEl = document.getElementById('px-config');
      var cfg = cfgEl ? JSON.parse(cfgEl.textContent) : null;
      if (cfg && cfg.locale) return cfg.locale === 'en';
    } catch (e) { /* Shopify locale fallback below */ }
    return document.documentElement.lang === 'en' || location.pathname.indexOf('/en/') === 0;
  })();

  var TEXT = en ? {
    without: 'Without textile banner',
    with: 'With textile banner',
    banner: 'Textile banner',
    active: 'Active',
    fabric: 'Choose fabric type',
    recommended: 'Recommended',
    method: 'Choose artwork type',
    upload: 'Own file',
    catalogue: 'Catalogue motif',
    unprinted: 'Unprinted',
    uploadTitle: 'Upload your own image file',
    max: '(max. 20 MB)',
    drop: 'Drop file here or click to upload',
    formats: 'PDF, JPG, PNG, TIFF – max. 20 MB',
    remove: 'Remove file',
    noFile: 'No file selected yet',
    unprintedNote: 'This textile banner will be supplied unprinted.',
    printData: 'Print data processing',
    prev: 'Previous textile banners',
    next: 'Next textile banners',
    fileTooLarge: 'The selected file is larger than 20 MB.',
    fileType: 'Please select a JPG, PNG, PDF, TIFF, AI or EPS file.',
    uploadFailed: 'The file could not be assigned to the upload field.',
    catalogueEmpty: 'No catalogue motif is available.',
    selected: 'Selected'
  } : {
    without: 'Ohne Stoffbanner',
    with: 'Mit Stoffbanner',
    banner: 'Stoffbanner',
    active: 'Aktiv',
    fabric: 'Stoffart wählen',
    recommended: 'Empfohlen',
    method: 'Art der Gestaltung wählen',
    upload: 'Eigene Datei',
    catalogue: 'Katalogmotiv',
    unprinted: 'Unbedruckt',
    uploadTitle: 'Eigene Bilddatei hochladen',
    max: '(max. 20 MB)',
    drop: 'Datei hierher ziehen oder klicken zum Hochladen',
    formats: 'PDF, JPG, PNG, TIFF – max. 20 MB',
    remove: 'Datei entfernen',
    noFile: 'Noch keine Datei ausgewählt',
    unprintedNote: 'Dieses Stoffbanner wird unbedruckt geliefert.',
    printData: 'Druckdatenverarbeitung',
    prev: 'Vorherige Stoffbanner',
    next: 'Nächste Stoffbanner',
    fileTooLarge: 'Die ausgewählte Datei ist größer als 20 MB.',
    fileType: 'Bitte wählen Sie eine JPG-, PNG-, PDF-, TIFF-, AI- oder EPS-Datei.',
    uploadFailed: 'Die Datei konnte dem Upload-Feld nicht zugewiesen werden.',
    catalogueEmpty: 'Es ist kein Katalogmotiv verfügbar.',
    selected: 'Ausgewählt'
  };

  var CHECK_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" aria-hidden="true"><path d="M5 13l4 4L19 7"/></svg>';
  var CHEVRON_RIGHT = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M9 5l7 7-7 7"/></svg>';
  var CHEVRON_DOWN = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M5 9l7 7 7-7"/></svg>';
  var UPLOAD_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="M12 16V4M7 9l5-5 5 5M4 17v3h16v-3"/></svg>';
  var IMAGE_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><rect x="3" y="4" width="18" height="16" rx="1"/><circle cx="9" cy="9" r="1.5"/><path d="M4 17l5-5 3 3 2-2 6 5"/></svg>';
  var NO_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M6 6l12 12"/></svg>';
  var ARROW_LEFT = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M15 5l-7 7 7 7"/></svg>';
  var ARROW_RIGHT = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M9 5l7 7-7 7"/></svg>';

  function esc(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function fireChange(el) {
    if (!el) return;
    el.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function notifyPricing() {
    var ev;
    try {
      ev = new CustomEvent('px:pricing-change', { bubbles: true });
    } catch (e) {
      ev = document.createEvent('CustomEvent');
      ev.initCustomEvent('px:pricing-change', true, false, {});
    }
    root.dispatchEvent(ev);
  }

  function slotNumber(slot) {
    return parseInt(slot.dataset.slot, 10) || 1;
  }

  function slotByNumber(number) {
    for (var i = 0; i < slots.length; i++) {
      if (slotNumber(slots[i]) === number) return slots[i];
    }
    return null;
  }

  function stateInput(slot, kind) {
    if (!slot) return null;
    var input = slot.querySelector('.px-hw-design-' + kind);
    if (input) return input;
    input = document.createElement('input');
    input.type = 'hidden';
    input.className = 'px-hw-design-' + kind;
    input.dataset.slot = String(slotNumber(slot));
    input.value = '';
    slot.insertBefore(input, slot.firstChild);
    return input;
  }

  function uploadInput(slot) {
    return slot ? slot.querySelector('.px-hw-upinput') : null;
  }

  var catalogueSource = document.getElementById('px-hw-catalog-source');
  var sourceTiles = catalogueSource ? Array.prototype.slice.call(catalogueSource.querySelectorAll('.px-hw-catalog-tile')) : [];
  var hasCatalogue = sourceTiles.length > 0;

  function normalizeInitialStates() {
    slots.forEach(function (slot, index) {
      var mode = stateInput(slot, 'mode');
      stateInput(slot, 'code');
      stateInput(slot, 'name');
      stateInput(slot, 'image');
      stateInput(slot, 'price');

      if (!mode.value) {
        if (index === 0 && uploadInput(slot)) mode.value = 'upload';
        else if (index === 0 && hasCatalogue) mode.value = 'catalog';
        else mode.value = 'unprinted';
      }
      if (mode.value === 'upload' && !uploadInput(slot)) {
        mode.value = hasCatalogue && index === 0 ? 'catalog' : 'unprinted';
      }
      if (mode.value === 'catalog' && !hasCatalogue) {
        mode.value = uploadInput(slot) && index === 0 ? 'upload' : 'unprinted';
      }
    });
  }
  normalizeInitialStates();

  function selectedModeCount() {
    var active = modeRow ? modeRow.querySelector('.px-exec-btn.px-active') : null;
    return active ? (parseInt(active.dataset.count, 10) || 0) : 0;
  }

  function textilesEnabled() {
    return selectedModeCount() > 0;
  }

  function getMode(number) {
    var slot = slotByNumber(number);
    var input = stateInput(slot, 'mode');
    var value = input ? input.value : 'unprinted';
    if (value !== 'upload' && value !== 'catalog' && value !== 'unprinted') value = 'unprinted';
    return value;
  }

  function setState(number, kind, value, notify) {
    var slot = slotByNumber(number);
    var input = stateInput(slot, kind);
    if (!input || input.value === String(value == null ? '' : value)) return;
    input.value = String(value == null ? '' : value);
    if (notify !== false) fireChange(input);
  }

  function selectedCatalogue(number) {
    var slot = slotByNumber(number);
    return {
      code: stateInput(slot, 'code').value,
      name: stateInput(slot, 'name').value,
      image: stateInput(slot, 'image').value,
      price: parseFloat(stateInput(slot, 'price').value || '0') || 0
    };
  }

  function selectedFile(number) {
    var input = uploadInput(slotByNumber(number));
    return input && input.files && input.files.length ? input.files[0] : null;
  }

  function fileIsPreviewable(file) {
    if (!file) return false;
    if (file.type && file.type.indexOf('image/') === 0) return true;
    return /\.(jpe?g|png|gif|webp|bmp|tiff?|svg|avif)$/i.test(file.name || '');
  }

  function slotComplete(number) {
    var mode = getMode(number);
    if (mode === 'unprinted') return true;
    if (mode === 'catalog') return !!selectedCatalogue(number).code;
    return !!selectedFile(number);
  }

  function notifyPreview() {
    root.dataset.pxActiveTextileSlot = String(activeSlot);
    var event;
    try {
      event = new CustomEvent('px:textile-preview-change', {
        bubbles: true,
        detail: { slot: activeSlot, mode: getMode(activeSlot) }
      });
    } catch (e) {
      event = document.createEvent('CustomEvent');
      event.initCustomEvent('px:textile-preview-change', true, false, {
        slot: activeSlot,
        mode: getMode(activeSlot)
      });
    }
    root.dispatchEvent(event);
  }

  // Keep the real mode controls. Only their visual content changes.
  modeRow.classList.add('pxhw-mode-row');
  modeButtons.forEach(function (button) {
    var on = (parseInt(button.dataset.count, 10) || 0) > 0;
    button.innerHTML = '<span>' + esc(on ? TEXT.with : TEXT.without) + '</span><span class="pxhw-mode-check">' + CHECK_SVG + '</span>';
    button.setAttribute('aria-pressed', button.classList.contains('px-active') ? 'true' : 'false');
  });

  var shell = document.createElement('div');
  shell.className = 'pxhw-shell';
  shell.innerHTML =
    '<div class="pxhw-slider">' +
      '<button type="button" class="pxhw-slider-arrow pxhw-slider-prev" aria-label="' + esc(TEXT.prev) + '">' + ARROW_LEFT + '</button>' +
      '<div class="pxhw-viewport"><div class="pxhw-track"></div></div>' +
      '<button type="button" class="pxhw-slider-arrow pxhw-slider-next" aria-label="' + esc(TEXT.next) + '">' + ARROW_RIGHT + '</button>' +
    '</div>' +
    '<div class="pxhw-method-block">' +
      '<div class="pxhw-section-label">' + esc(TEXT.method) + '</div>' +
      '<div class="pxhw-methods">' +
        '<button type="button" class="pxhw-method" data-pxhw-method="upload">' + UPLOAD_SVG + '<span>' + esc(TEXT.upload) + '</span></button>' +
        '<button type="button" class="pxhw-method" data-pxhw-method="catalog">' + IMAGE_SVG + '<span>' + esc(TEXT.catalogue) + '</span></button>' +
        '<button type="button" class="pxhw-method" data-pxhw-method="unprinted">' + NO_SVG + '<span>' + esc(TEXT.unprinted) + '</span></button>' +
      '</div>' +
    '</div>' +
    '<div class="pxhw-editor" data-mode="upload">' +
      '<div class="pxhw-upload-editor">' +
        '<div class="pxhw-section-label"><span>' + esc(TEXT.uploadTitle) + '</span> <span class="pxhw-muted">' + esc(TEXT.max) + '</span></div>' +
        '<div class="pxhw-dropzone" role="button" tabindex="0">' +
          '<span class="pxhw-drop-icon">' + UPLOAD_SVG + '</span>' +
          '<strong>' + esc(TEXT.drop) + '</strong>' +
          '<small>' + esc(TEXT.formats) + '</small>' +
        '</div>' +
        '<div class="pxhw-file-row" hidden><span class="pxhw-file-name"></span><button type="button" class="pxhw-file-remove" aria-label="' + esc(TEXT.remove) + '">×</button></div>' +
      '</div>' +
      '<div class="pxhw-catalog-editor" hidden></div>' +
      '<div class="pxhw-unprinted-editor" hidden>' + NO_SVG + '<span>' + esc(TEXT.unprintedNote) + '</span></div>' +
      '<div class="pxhw-pd-editor" hidden></div>' +
    '</div>';
  modeRow.parentNode.insertBefore(shell, modeRow.nextSibling);

  var track = shell.querySelector('.pxhw-track');
  var viewport = shell.querySelector('.pxhw-viewport');
  var prevButton = shell.querySelector('.pxhw-slider-prev');
  var nextButton = shell.querySelector('.pxhw-slider-next');
  var methodButtons = Array.prototype.slice.call(shell.querySelectorAll('.pxhw-method'));
  var uploadMethod = shell.querySelector('[data-pxhw-method="upload"]');
  var catalogMethod = shell.querySelector('[data-pxhw-method="catalog"]');
  var editor = shell.querySelector('.pxhw-editor');
  var uploadEditor = shell.querySelector('.pxhw-upload-editor');
  var catalogueEditor = shell.querySelector('.pxhw-catalog-editor');
  var unprintedEditor = shell.querySelector('.pxhw-unprinted-editor');
  var pdEditor = shell.querySelector('.pxhw-pd-editor');
  var dropzone = shell.querySelector('.pxhw-dropzone');
  var fileRow = shell.querySelector('.pxhw-file-row');
  var fileName = shell.querySelector('.pxhw-file-name');
  var fileRemove = shell.querySelector('.pxhw-file-remove');

  var activeSlot = 1;
  var pageStart = 0;
  var objectUrls = {};
  var cards = [];

  function cardTitle(number, slot) {
    // Keep the product's configured slot label (e.g. "Stoffbanner 1 – vorne")
    // so the card title matches the established configurator design. Fall back
    // to a neutral numbered label when the slot has no specific label.
    var label = slot ? String(slot.dataset.label || '').trim() : '';
    var generic = label.toLowerCase();
    if (label && generic !== 'stoffbanner' && generic !== 'textile banner') return label;
    return TEXT.banner + ' ' + number;
  }

  function ensureAvailableFabric(select, notify) {
    if (!select || !select.options || !select.options.length) return false;
    var current = select.selectedIndex >= 0 ? select.options[select.selectedIndex] : null;
    if (current && !current.disabled) return false;
    for (var i = 0; i < select.options.length; i++) {
      if (!select.options[i].disabled) {
        select.selectedIndex = i;
        if (notify !== false) fireChange(select);
        return true;
      }
    }
    select.selectedIndex = -1;
    return false;
  }

  function buildFabricOptions(slot, number) {
    var select = slot.querySelector('.px-hw-fabric');
    if (!select) return '';
    ensureAvailableFabric(select, true);
    var html = '';
    Array.prototype.forEach.call(select.options, function (option, index) {
      var title = option.dataset.title || option.text;
      html +=
        '<button type="button" class="pxhw-fabric-option" data-value="' + esc(option.value) + '"' + (option.disabled ? ' disabled' : '') + '>' +
          '<span class="pxhw-radio" aria-hidden="true"></span>' +
          '<span class="pxhw-fabric-name">' + esc(title) + '</span>' +
          (index === 0 ? '<span class="pxhw-recommended">' + esc(TEXT.recommended) + '</span>' : '') +
        '</button>';
    });
    return html;
  }

  slots.forEach(function (slot) {
    var number = slotNumber(slot);
    var card = document.createElement('article');
    card.className = 'pxhw-card';
    card.dataset.slot = String(number);
    card.innerHTML =
      '<div class="pxhw-card-head">' +
        '<span class="pxhw-card-number">' + number + '</span>' +
        '<strong>' + esc(cardTitle(number, slot)) + '</strong>' +
        '<span class="pxhw-active-badge">' + esc(TEXT.active) + '</span>' +
      '</div>' +
      '<button type="button" class="pxhw-card-summary" aria-label="' + esc(cardTitle(number, slot)) + '">' +
        '<span class="pxhw-thumb"><span class="pxhw-thumb-placeholder">' + NO_SVG + '</span><img alt="" hidden></span>' +
        '<span class="pxhw-summary-copy"><span class="pxhw-summary-line"><span class="pxhw-status-check">' + CHECK_SVG + '</span><span class="pxhw-status-text"></span></span><small class="pxhw-file-hint"></small></span>' +
        '<span class="pxhw-card-next">' + CHEVRON_RIGHT + '</span>' +
      '</button>' +
      '<button type="button" class="pxhw-fabric-toggle" aria-expanded="false">' +
        '<span>' + esc(TEXT.fabric) + '</span><span class="pxhw-fabric-chevron">' + CHEVRON_DOWN + '</span>' +
      '</button>' +
      '<div class="pxhw-fabric-panel" hidden>' +
        '<div class="pxhw-fabric-panel-label">' + esc(TEXT.fabric) + '</div>' +
        buildFabricOptions(slot, number) +
      '</div>';

    track.appendChild(card);
    cards.push(card);

    var summary = card.querySelector('.pxhw-card-summary');
    var toggle = card.querySelector('.pxhw-fabric-toggle');
    var panel = card.querySelector('.pxhw-fabric-panel');

    // Match the original card interaction: the whole card face/summary is the
    // accordion trigger. The separate "Stoffart wählen" bar remains in the
    // DOM for compatibility but is visually hidden by CSS.
    summary.addEventListener('click', function () {
      var wasOpen = !panel.hasAttribute('hidden');
      selectCard(number, false);
      closeFabricPanels(card);
      if (!wasOpen) {
        panel.removeAttribute('hidden');
        toggle.setAttribute('aria-expanded', 'true');
        card.classList.add('is-fabric-open');
      } else {
        panel.setAttribute('hidden', '');
        toggle.setAttribute('aria-expanded', 'false');
        card.classList.remove('is-fabric-open');
      }
      updateSliderPosition();
    });
    toggle.addEventListener('click', function () {
      var wasOpen = !panel.hasAttribute('hidden');
      selectCard(number, false);
      closeFabricPanels(card);
      if (!wasOpen) {
        panel.removeAttribute('hidden');
        toggle.setAttribute('aria-expanded', 'true');
        card.classList.add('is-fabric-open');
      } else {
        panel.setAttribute('hidden', '');
        toggle.setAttribute('aria-expanded', 'false');
        card.classList.remove('is-fabric-open');
      }
      updateSliderPosition();
    });
    card.querySelectorAll('.pxhw-fabric-option').forEach(function (button) {
      button.addEventListener('click', function () {
        if (button.disabled) return;
        var select = slot.querySelector('.px-hw-fabric');
        if (!select) return;
        select.value = button.dataset.value;
        fireChange(select);
        panel.setAttribute('hidden', '');
        toggle.setAttribute('aria-expanded', 'false');
        card.classList.remove('is-fabric-open');
        selectCard(number, false);
        renderAll();
      });
    });
  });

  function closeFabricPanels(exceptCard) {
    cards.forEach(function (card) {
      if (card === exceptCard) return;
      var panel = card.querySelector('.pxhw-fabric-panel');
      var toggle = card.querySelector('.pxhw-fabric-toggle');
      panel.setAttribute('hidden', '');
      toggle.setAttribute('aria-expanded', 'false');
      card.classList.remove('is-fabric-open');
    });
  }

  // All textile cards start CLOSED. The native select still keeps its first
  // available fabric selected, so pricing is valid before the customer opens
  // a card. Choosing another fabric closes the card again (see click handler).
  closeFabricPanels(null);

  function catalogueClone() {
    if (!catalogueSource || !hasCatalogue) return null;
    var clone = catalogueSource.cloneNode(true);
    clone.removeAttribute('id');
    clone.removeAttribute('hidden');
    clone.classList.add('pxhw-catalog-ui');
    catalogueEditor.appendChild(clone);

    var select = clone.querySelector('.px-hw-catalog-select');
    var panels = Array.prototype.slice.call(clone.querySelectorAll('.px-hw-catalog-panel'));
    var tiles = Array.prototype.slice.call(clone.querySelectorAll('.px-hw-catalog-tile'));

    function showPanel(value) {
      panels.forEach(function (panel) {
        if (panel.dataset.catalog === value) panel.removeAttribute('hidden');
        else panel.setAttribute('hidden', '');
      });
    }
    if (select) {
      if (select.options.length <= 1) select.classList.add('pxhw-single-catalog');
      select.addEventListener('change', function () { showPanel(select.value); });
      showPanel(select.value);
    }
    tiles.forEach(function (tile) {
      tile.addEventListener('click', function () {
        setState(activeSlot, 'code', tile.dataset.code || '', false);
        setState(activeSlot, 'name', tile.dataset.name || '', false);
        setState(activeSlot, 'image', tile.dataset.image || tile.dataset.thumb || '', false);
        setState(activeSlot, 'price', tile.dataset.price || '0', false);
        fireChange(stateInput(slotByNumber(activeSlot), 'code'));
        notifyPricing();
        renderAll();
        notifyPreview();
      });
    });
    return { root: clone, select: select, panels: panels, tiles: tiles, showPanel: showPanel };
  }

  var catalogueUi = catalogueClone();
  if (!hasCatalogue && catalogMethod) catalogMethod.hidden = true;

  function buildPdEditor() {
    var real = document.getElementById('px-hw-pd-select');
    if (!real) return null;
    var label = document.createElement('label');
    label.className = 'pxhw-pd-field';
    label.innerHTML = '<span class="pxhw-section-label">' + esc(TEXT.printData) + '</span>';
    var select = document.createElement('select');
    select.className = 'px-select pxhw-pd-select';
    Array.prototype.forEach.call(real.options, function (option) {
      var clone = option.cloneNode(true);
      select.appendChild(clone);
    });
    select.value = real.value;
    label.appendChild(select);
    pdEditor.appendChild(label);
    select.addEventListener('change', function () {
      real.value = select.value;
      fireChange(real);
    });
    real.addEventListener('change', function () { select.value = real.value; });
    return { real: real, select: select };
  }
  var pdUi = buildPdEditor();

  function activeUploadInput() {
    return uploadInput(slotByNumber(activeSlot));
  }

  function allowedFile(file) {
    if (!file) return false;
    if (file.size > 20 * 1024 * 1024) {
      window.alert(TEXT.fileTooLarge);
      return false;
    }
    if (file.type && (file.type.indexOf('image/') === 0 || file.type === 'application/pdf')) return true;
    if (/\.(jpe?g|png|gif|webp|bmp|tiff?|svg|avif|pdf|ai|eps)$/i.test(file.name || '')) return true;
    window.alert(TEXT.fileType);
    return false;
  }

  function assignFile(file) {
    var input = activeUploadInput();
    if (!input || !allowedFile(file)) return;
    try {
      var dt = new DataTransfer();
      dt.items.add(file);
      input.files = dt.files;
      fireChange(input);
      setState(activeSlot, 'mode', 'upload');
      renderAll();
      notifyPreview();
    } catch (e) {
      console.error('[PX textile cards] File assignment failed', e);
      window.alert(TEXT.uploadFailed);
    }
  }

  function clearFile(number, notify) {
    var input = uploadInput(slotByNumber(number));
    if (!input || !input.value) return;
    input.value = '';
    if (notify !== false) fireChange(input);
  }

  dropzone.addEventListener('click', function () {
    var input = activeUploadInput();
    if (input) input.click();
  });
  dropzone.addEventListener('keydown', function (event) {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      dropzone.click();
    }
  });
  ['dragenter', 'dragover'].forEach(function (name) {
    dropzone.addEventListener(name, function (event) {
      event.preventDefault();
      event.stopPropagation();
      dropzone.classList.add('is-dragover');
    });
  });
  ['dragleave', 'drop'].forEach(function (name) {
    dropzone.addEventListener(name, function (event) {
      event.preventDefault();
      event.stopPropagation();
      dropzone.classList.remove('is-dragover');
    });
  });
  dropzone.addEventListener('drop', function (event) {
    var files = event.dataTransfer && event.dataTransfer.files;
    if (files && files.length) assignFile(files[0]);
  });
  fileRemove.addEventListener('click', function () {
    clearFile(activeSlot);
    renderAll();
    notifyPreview();
  });

  slots.forEach(function (slot) {
    var input = uploadInput(slot);
    if (input) {
      input.addEventListener('change', function () {
        renderAll();
        notifyPreview();
      });
    }
    var list = slot.querySelector('.px-hw-uplist');
    if (list && typeof MutationObserver === 'function') {
      new MutationObserver(function () {
        renderAll();
        notifyPreview();
      }).observe(list, { childList: true, subtree: true });
    }
    var select = slot.querySelector('.px-hw-fabric');
    if (select) {
      select.addEventListener('change', renderAll);

      // primex-configurator.js is the authority for fabric availability.
      // Mirror enabled/disabled native options into the visual Messesystem card.
      if ('MutationObserver' in window) {
        new MutationObserver(function () {
          renderAll();
        }).observe(select, {
          subtree: true,
          attributes: true,
          attributeFilter: ['disabled']
        });
      }
    }
  });

  function firstCatalogueTileForCurrentCategory() {
    if (!catalogueUi || !catalogueUi.tiles.length) return null;
    if (catalogueUi.select && catalogueUi.select.value) {
      for (var i = 0; i < catalogueUi.panels.length; i++) {
        var panel = catalogueUi.panels[i];
        if (panel.dataset.catalog !== catalogueUi.select.value) continue;
        var tile = panel.querySelector('.px-hw-catalog-tile');
        if (tile) return tile;
      }
    }
    return catalogueUi.tiles[0] || null;
  }

  function selectFirstCatalogue(number) {
    var tile = firstCatalogueTileForCurrentCategory();
    if (!tile) return false;
    setState(number, 'code', tile.dataset.code || '', false);
    setState(number, 'name', tile.dataset.name || '', false);
    setState(number, 'image', tile.dataset.image || tile.dataset.thumb || '', false);
    setState(number, 'price', tile.dataset.price || '0', false);
    fireChange(stateInput(slotByNumber(number), 'code'));
    notifyPricing();
    return true;
  }

  function setMode(number, mode) {
    var slot = slotByNumber(number);
    if (!slot) return;
    if (mode === 'upload' && !uploadInput(slot)) {
      mode = hasCatalogue ? 'catalog' : 'unprinted';
    }
    if (mode === 'catalog' && !hasCatalogue) mode = uploadInput(slot) ? 'upload' : 'unprinted';

    if (mode !== 'upload') clearFile(number);
    if (mode === 'catalog' && !selectedCatalogue(number).code) {
      if (!selectFirstCatalogue(number)) {
        window.alert(TEXT.catalogueEmpty);
        return;
      }
    }
    setState(number, 'mode', mode);
    renderAll();
    notifyPreview();
    notifyPricing();
  }

  methodButtons.forEach(function (button) {
    button.addEventListener('click', function () {
      setMode(activeSlot, button.dataset.pxhwMethod);
    });
  });

  function syncCatalogueUi() {
    if (!catalogueUi) return;
    var selected = selectedCatalogue(activeSlot);
    var chosenTile = null;
    catalogueUi.tiles.forEach(function (tile) {
      var chosen = !!selected.code && tile.dataset.code === selected.code;
      tile.classList.toggle('is-selected', chosen);
      tile.setAttribute('aria-pressed', chosen ? 'true' : 'false');
      if (chosen) chosenTile = tile;
    });
    if (chosenTile && catalogueUi.select) {
      var panel = chosenTile.closest('.px-hw-catalog-panel');
      if (panel && catalogueUi.select.value !== panel.dataset.catalog) {
        catalogueUi.select.value = panel.dataset.catalog;
        catalogueUi.showPanel(panel.dataset.catalog);
      }
    }
  }

  function objectUrlFor(number, file) {
    if (!file || !fileIsPreviewable(file)) return null;
    var key = file.name + ':' + file.size + ':' + file.lastModified;
    var current = objectUrls[number];
    if (current && current.key === key) return current.url;
    if (current && current.url) {
      try { URL.revokeObjectURL(current.url); } catch (e) { /* no-op */ }
    }
    var url = URL.createObjectURL(file);
    objectUrls[number] = { key: key, url: url };
    return url;
  }

  function clearObjectUrl(number) {
    var current = objectUrls[number];
    if (!current) return;
    try { URL.revokeObjectURL(current.url); } catch (e) { /* no-op */ }
    delete objectUrls[number];
  }

  function updateCard(card) {
    var number = parseInt(card.dataset.slot, 10);
    var slot = slotByNumber(number);
    var mode = getMode(number);
    var complete = slotComplete(number);
    var selected = number === activeSlot;
    var select = slot ? slot.querySelector('.px-hw-fabric') : null;
    var selectedFabric = select && select.options[select.selectedIndex];

    card.classList.toggle('is-active', selected);
    card.classList.toggle('is-complete', complete);
    card.querySelector('.pxhw-active-badge').style.display = selected ? '' : 'none';

    var status = mode === 'catalog' ? TEXT.catalogue : (mode === 'unprinted' ? TEXT.unprinted : TEXT.upload);
    card.querySelector('.pxhw-status-text').textContent = status;
    var hint = card.querySelector('.pxhw-file-hint');
    if (mode === 'upload') {
      var file = selectedFile(number);
      hint.textContent = file ? file.name : TEXT.noFile;
    } else if (mode === 'catalog') {
      hint.textContent = selectedCatalogue(number).name || '';
    } else {
      hint.textContent = selectedFabric ? (selectedFabric.dataset.title || selectedFabric.text) : '';
    }

    var img = card.querySelector('.pxhw-thumb img');
    var placeholder = card.querySelector('.pxhw-thumb-placeholder');
    var src = null;
    if (mode === 'upload') {
      var previewFile = selectedFile(number);
      if (previewFile && fileIsPreviewable(previewFile)) src = objectUrlFor(number, previewFile);
      else clearObjectUrl(number);
    } else {
      clearObjectUrl(number);
      if (mode === 'catalog') src = selectedCatalogue(number).image || null;
    }
    if (src) {
      img.src = src;
      img.hidden = false;
      placeholder.hidden = true;
    } else {
      img.hidden = true;
      img.removeAttribute('src');
      placeholder.hidden = false;
      placeholder.innerHTML = mode === 'upload' ? UPLOAD_SVG : (mode === 'catalog' ? IMAGE_SVG : NO_SVG);
    }

    if (select) {
      card.querySelectorAll('.pxhw-fabric-option').forEach(function (button) {
        var chosen = button.dataset.value === select.value;
        button.classList.toggle('is-selected', chosen);
        button.setAttribute('aria-pressed', chosen ? 'true' : 'false');
        var option = null;
        for (var i = 0; i < select.options.length; i++) {
          if (select.options[i].value === button.dataset.value) { option = select.options[i]; break; }
        }
        button.disabled = !!(option && option.disabled);
      });
    }
  }

  function syncUploadEditor() {
    var file = selectedFile(activeSlot);
    var input = activeUploadInput();
    uploadMethod.hidden = !input;
    if (file) {
      fileRow.hidden = false;
      fileName.textContent = file.name;
    } else {
      fileRow.hidden = true;
      fileName.textContent = '';
    }
  }

  function syncMethodsAndEditor() {
    var mode = getMode(activeSlot);
    var slot = slotByNumber(activeSlot);
    if (mode === 'upload' && !uploadInput(slot)) mode = hasCatalogue ? 'catalog' : 'unprinted';
    if (mode === 'catalog' && !hasCatalogue) mode = uploadInput(slot) ? 'upload' : 'unprinted';

    methodButtons.forEach(function (button) {
      var active = button.dataset.pxhwMethod === mode;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
    editor.dataset.mode = mode;
    uploadEditor.hidden = mode !== 'upload';
    catalogueEditor.hidden = mode !== 'catalog';
    unprintedEditor.hidden = mode !== 'unprinted';
    pdEditor.hidden = !(mode === 'upload' && !!pdUi);
    syncUploadEditor();
    syncCatalogueUi();
  }

  function cardsPerPage() {
    return window.matchMedia && window.matchMedia('(max-width: 749px)').matches ? 1 : 2;
  }

  function ensureActivePage() {
    var perPage = cardsPerPage();
    var index = Math.max(0, activeSlot - 1);
    if (index < pageStart) pageStart = Math.floor(index / perPage) * perPage;
    if (index >= pageStart + perPage) pageStart = Math.floor(index / perPage) * perPage;
  }

  function updateSliderPosition() {
    if (!cards.length || !viewport) return;
    var perPage = cardsPerPage();
    var maxStart = Math.max(0, cards.length - perPage);
    if (pageStart > maxStart) pageStart = maxStart;
    if (pageStart < 0) pageStart = 0;
    var cardWidth = cards[0].getBoundingClientRect().width;
    var gap = parseFloat(window.getComputedStyle(track).gap || '0') || 0;
    track.style.transform = 'translate3d(' + (-pageStart * (cardWidth + gap)) + 'px,0,0)';
    prevButton.disabled = pageStart <= 0;
    nextButton.disabled = pageStart >= maxStart;
    var needArrows = cards.length > perPage;
    prevButton.hidden = !needArrows;
    nextButton.hidden = !needArrows;
  }

  prevButton.addEventListener('click', function () {
    pageStart -= cardsPerPage();
    if (pageStart < 0) pageStart = 0;
    selectCard(pageStart + 1, false);
  });
  nextButton.addEventListener('click', function () {
    var perPage = cardsPerPage();
    pageStart += perPage;
    var maxStart = Math.max(0, cards.length - perPage);
    if (pageStart > maxStart) pageStart = maxStart;
    selectCard(pageStart + 1, false);
  });

  function selectCard(number, openFabric) {
    activeSlot = number;
    root.dataset.pxActiveTextileSlot = String(number);
    closeFabricPanels(openFabric ? cards[number - 1] : null);
    if (openFabric) {
      var card = cards[number - 1];
      if (card) {
        card.querySelector('.pxhw-fabric-panel').removeAttribute('hidden');
        card.querySelector('.pxhw-fabric-toggle').setAttribute('aria-expanded', 'true');
        card.classList.add('is-fabric-open');
      }
    }
    ensureActivePage();
    renderAll();
    notifyPreview();
  }

  function renderModeButtons() {
    modeButtons.forEach(function (button) {
      var active = button.classList.contains('px-active');
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }

  // v15.4: publish the catalogue surcharge as one authoritative product-level
  // value for Messesystem/Handelsware. The individual cards keep their own motif
  // state for production, but catalogue artwork is charged only ONCE for this
  // product family, even if several textile slots use catalogue motifs.
  function publishHwCataloguePricing() {
    var count = selectedModeCount();
    var surcharge = 0;
    for (var i = 1; i <= count; i++) {
      if (getMode(i) !== 'catalog') continue;
      var cat = selectedCatalogue(i);
      if (cat && cat.code) {
        surcharge = parseFloat(cat.price || '0') || 0;
        break;
      }
    }
    var oldMode = root.dataset.pxCataloguePricingMode || '';
    var oldValue = root.dataset.pxCatalogueSurcharge || '';
    var nextValue = String(surcharge);
    root.dataset.pxCataloguePricingMode = 'hw';
    root.dataset.pxCatalogueSurcharge = nextValue;
    if (oldMode !== 'hw' || oldValue !== nextValue) notifyPricing();
  }

  function renderAll() {
    publishHwCataloguePricing();
    var enabled = textilesEnabled();
    shell.hidden = !enabled;
    renderModeButtons();
    if (!enabled) {
      notifyPreview();
      return;
    }
    cards.forEach(updateCard);
    syncMethodsAndEditor();
    ensureActivePage();
    window.requestAnimationFrame(updateSliderPosition);
  }

  modeButtons.forEach(function (button) {
    button.addEventListener('click', function () {
      // primex-configurator.js registered first and therefore updates hwCount,
      // pricing and .px-active before this zero-delay UI synchronization runs.
      setTimeout(function () {
        if (textilesEnabled()) {
          if (!root.dataset.pxActiveTextileSlot) {
            activeSlot = 1;
            root.dataset.pxActiveTextileSlot = '1';
          }
          // Re-entering "Mit Stoffbanner" must not reopen a fabric panel.
          closeFabricPanels(null);
        }
        renderAll();
        notifyPreview();
      }, 0);
    });
  });

  if (catalogueUi && catalogueUi.select) {
    catalogueUi.select.addEventListener('change', function () {
      catalogueUi.showPanel(catalogueUi.select.value);
      if (getMode(activeSlot) === 'catalog') {
        // A catalogue category is a complete choice only when it has a motif.
        // Always select that category's first motif immediately, including its
        // metaobject price, so the card thumbnail and pricing update together.
        selectFirstCatalogue(activeSlot);
      }
      renderAll();
      notifyPreview();
    });
  }

  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      ensureActivePage();
      updateSliderPosition();
    }, 100);
  });
  window.addEventListener('beforeunload', function () {
    Object.keys(objectUrls).forEach(function (key) { clearObjectUrl(key); });
  });

  wrap.classList.add('pxhw-enhanced');
  root.dataset.pxActiveTextileSlot = String(activeSlot);
  renderAll();
})();


/* =====================================================================
   PRIMEX — Formula / round / dual-fabric card UI
   Runs only when #px-hw-textile is NOT present.
   ===================================================================== */

/**
 * PRIMEX — assets/primex-textile-cards.js (v1.3)
 *
 * Generalizes the card-based Bild & Druck UI (built for Handelsware in
 * primex-hw-cards.js) to every OTHER product that has a fabric select
 * and/or upload/catalogue/print options — regular Formula products,
 * Round products with a linked fabric (v14.6), and the Akustik family
 * (showFabricSelect). This script does NOT touch Handelsware products at
 * all (#px-hw-textile) — those keep using primex-hw-cards.js untouched.
 *
 * SCOPE, DELIBERATELY:
 *   - Single-fabric products (#px-fabric-select, no #px-fabric-select2):
 *     ONE card (fabric list) + ONE shared "Art der Gestaltung wählen"
 *     panel below it (Eigene Datei / Katalogmotiv-if-linked /
 *     Unbedruckt-if-a-print-toggle-exists), exactly mirroring the
 *     Handelsware pattern — because here, same as there, upload/catalogue/
 *     print really are one shared choice for the whole textile.
 *   - Stoffbanner (AREA_FIX, no fabric select at all): the shared
 *     "Art der Gestaltung" panel only, no card, since there's no fabric
 *     to choose.
 *   - dualFabric (#px-fabric-select2): TWO textile cards (front/back),
 *     while the real two native selects and the existing pricing logic stay
 *     authoritative. The shared artwork panel shows the upload zone for the
 *     currently active side; catalogue/print controls remain the existing
 *     global configurator controls.
 *
 * STRICTLY ADDITIVE — exactly like primex-hw-cards.js:
 *   - The real <select id="px-fabric-select"> stays exactly what pricing
 *     reads; this only sets its .value and dispatches a real 'change'.
 *   - "Eigene Datei" / "Katalogmotiv" / "Unbedruckt" DRIVE the real
 *     #px-print buttons and #px-design-toggle checkbox via real
 *     click/change events — they do not reimplement any pricing logic.
 *     Unlike Handelsware's "Unbedruckt" (which is price-neutral because no
 *     formula exists for it there), THIS "Unbedruckt" is the real
 *     "Ohne Druck" button underneath, so it correctly removes the
 *     print-data fee exactly as it always did.
 */
(function () {
  'use strict';

  var root = document.getElementById('px-configurator');
  if (!root) return;
  if (document.getElementById('px-hw-textile')) return; // Handelsware: primex-hw-cards.js owns this

  var section = document.getElementById('px-textile-section');
  var fabricSelect = document.getElementById('px-fabric-select');
  var fabricSelect2 = document.getElementById('px-fabric-select2');
  var designWrap = document.getElementById('px-design-wrap');
  var designToggle = document.getElementById('px-design-toggle');
  var printBtns = root.querySelectorAll('.px-print-btn');

  var isDualFabric = !!fabricSelect2;

  var uploadWraps = section ? Array.prototype.slice.call(section.querySelectorAll('.px-upload-wrap')) : [];
  var hasAnything = !!(fabricSelect || fabricSelect2 || uploadWraps.length || designWrap);
  if (!hasAnything) return;

  function isEn() {
    try {
      var cfgEl = document.getElementById('px-config');
      if (cfgEl) {
        var cfg = JSON.parse(cfgEl.textContent);
        if (cfg && cfg.locale) return cfg.locale === 'en';
      }
    } catch (e) {}
    return document.documentElement.lang === 'en' || location.pathname.indexOf('/en/') === 0;
  }
  var L = isEn()
    ? { chooseFabric: 'Choose fabric', recommended: 'Recommended', upload: 'Own file', catalog: 'Catalogue motif',
        unprinted: 'Unprinted/white', active: 'Active', noFileYet: 'Choose...', modeHeading: 'Choose design type',
        textileTitle: 'Textile' }
    : { chooseFabric: 'Stoffart wählen', recommended: 'Empfohlen', upload: 'Eigene Datei', catalog: 'Katalogmotiv',
        unprinted: 'Unbedruckt/weiß', active: 'Aktiv', noFileYet: 'Wählen...', modeHeading: 'Art der Gestaltung wählen',
        textileTitle: 'Textil' };

  var CHECK_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M5 13l4 4L19 7"/></svg>';
  var CHEVRON_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M9 6l6 6-6 6"/></svg>';
  var NOIMG_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><circle cx="12" cy="12" r="9"/><path d="M4.5 19.5l15-15"/></svg>';
  var UPLOAD_ICON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M12 16V4M7 9l5-5 5 5M4 17v3h16v-3"/></svg>';
  var CATALOG_ICON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><path d="M21 15l-5-5L5 21"/></svg>';
  var UNPRINTED_ICON = NOIMG_SVG;

  function notifyPricing() {
    var ev;
    try {
      ev = new CustomEvent('px:pricing-change', { bubbles: true });
    } catch (e) {
      ev = document.createEvent('CustomEvent');
      ev.initCustomEvent('px:pricing-change', true, false, {});
    }
    root.dispatchEvent(ev);
  }

  // Remove/neutralize the simpler tab UI primex-ui-enhancements.js's
  // initImageTabs() would otherwise have already built on this same
  // section — this new card system fully supersedes it. (initImageTabs()
  // itself is also being disabled at its call site, but this guards
  // against load-order changes.)
  if (section) {
    var oldTabs = section.querySelector('.px-imgtabs');
    if (oldTabs) oldTabs.remove();
    section.classList.remove('px-has-tabs', 'px-tab-upload', 'px-tab-catalog');
  }

  var findRealPrintBtn = function (val) {
    var found = null;
    printBtns.forEach(function (b) { if (b.dataset.print === val) found = b; });
    return found;
  };
  var printYesBtn = findRealPrintBtn('YES');
  var printNoBtn = findRealPrintBtn('NO');

  // v1.1 fix: the ORIGINAL "Mit Druck / Ohne Druck" row was only ever read
  // for its buttons (to click them programmatically) — the container itself
  // was never hidden, so it kept showing in full alongside our new
  // "Unbedruckt/weiß" button: two controls doing the same job, visible at
  // once. Hide it now that our panel takes over its role.
  var printRow = document.getElementById('px-print');
  if (printRow && printYesBtn && printNoBtn) {
    printRow.style.display = 'none';
  }

  // v1.5: dualFabric front/back state is fully independent. The two cards share
  // one visible editor, but each side keeps its own design mode, catalogue motif,
  // upload and fabric. Native selects/inputs remain the source of truth for all
  // existing frame/fabric calculations.
  function initDualFabric() {
    if (!section || !fabricSelect || !fabricSelect2) return;

    section.classList.add('pxhw-enhanced');
    root.dataset.pxDualUiReady = '1';

    var sideDefs = [
      {
        index: 0,
        side: 'front',
        select: fabricSelect,
        labelEl: document.getElementById('px-fabric-label'),
        infoFor: 'px-fabric-select',
        title: isEn() ? 'Textile banner 1 – front' : 'Stoffbanner 1 – vorne'
      },
      {
        index: 1,
        side: 'back',
        select: fabricSelect2,
        labelEl: document.getElementById('px-fabric-label-back'),
        infoFor: 'px-fabric-select2',
        title: isEn() ? 'Textile banner 2 – back' : 'Stoffbanner 2 – hinten'
      }
    ];

    var noFileText = isEn() ? 'No file selected yet' : 'Noch keine Datei ausgewählt';
    var recommendedIcon = 'https://cdn.shopify.com/s/files/1/0643/3469/2616/files/thumbs_up_green.svg?v=1787828479';
    var objectUrls = {};
    var applyingSharedState = false;
    var cards = [];
    var activeIndex = 0;
    var panel = null;
    var modeRow = null;
    var modeContent = null;
    var hasCatalog = !!designWrap;
    var hasUnprinted = !!(printYesBtn && printNoBtn);

    function esc(s) {
      return String(s == null ? '' : s)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
    }

    function initialGlobalMode() {
      if (hasUnprinted && printNoBtn && printNoBtn.classList.contains('px-active')) return 'unprinted';
      if (hasCatalog && designToggle && designToggle.checked) return 'catalog';
      return 'upload';
    }

    var initialMode = initialGlobalMode();
    var sideState = {
      front: { mode: initialMode, catalog: { code: '', name: '', image: '', price: 0, catalog: '' } },
      back:  { mode: initialMode === 'catalog' ? 'upload' : initialMode, catalog: { code: '', name: '', image: '', price: 0, catalog: '' } }
    };

    function stateFor(side) {
      return sideState[side] || sideState.front;
    }

    function modeFor(side) {
      var mode = stateFor(side).mode;
      return (mode === 'catalog' || mode === 'unprinted') ? mode : 'upload';
    }

    function ensureStateInput(kind, side) {
      var cls = 'px-dual-design-' + kind;
      var el = section.querySelector('.' + cls + '[data-side="' + side + '"]');
      if (!el) {
        el = document.createElement('input');
        el.type = 'hidden';
        el.className = cls;
        el.dataset.side = side;
        section.appendChild(el);
      }
      return el;
    }

    function publishState() {
      var changed = false;
      ['front', 'back'].forEach(function (side) {
        var st = stateFor(side);
        var cat = st.catalog || {};
        var values = {
          mode: modeFor(side),
          code: cat.code || '',
          name: cat.name || '',
          image: cat.image || '',
          price: String(cat.price || 0),
          catalog: cat.catalog || ''
        };
        Object.keys(values).forEach(function (kind) {
          var input = ensureStateInput(kind, side);
          if (input.value !== values[kind]) {
            input.value = values[kind];
            changed = true;
          }
        });
      });

      root.dataset.pxDualModeFront = modeFor('front');
      root.dataset.pxDualModeBack = modeFor('back');
      root.dataset.pxDualMotifFrontCode = stateFor('front').catalog.code || '';
      root.dataset.pxDualMotifFrontName = stateFor('front').catalog.name || '';
      root.dataset.pxDualMotifFrontImage = stateFor('front').catalog.image || '';
      root.dataset.pxDualMotifBackCode = stateFor('back').catalog.code || '';
      root.dataset.pxDualMotifBackName = stateFor('back').catalog.name || '';
      root.dataset.pxDualMotifBackImage = stateFor('back').catalog.image || '';

      // v15.4: one authoritative catalogue-surcharge channel shared with the
      // pricing engine. dualFabric is the ONLY card family where the catalogue
      // service is charged per side: front + back.
      var catalogueSurcharge = 0;
      ['front', 'back'].forEach(function (side) {
        if (modeFor(side) !== 'catalog') return;
        var cat = stateFor(side).catalog || {};
        if (cat.code) catalogueSurcharge += parseFloat(cat.price || '0') || 0;
      });
      var oldPricingMode = root.dataset.pxCataloguePricingMode || '';
      var oldSurcharge = root.dataset.pxCatalogueSurcharge || '';
      var nextSurcharge = String(catalogueSurcharge);
      root.dataset.pxCataloguePricingMode = 'dual';
      root.dataset.pxCatalogueSurcharge = nextSurcharge;
      if (oldPricingMode !== 'dual' || oldSurcharge !== nextSurcharge) changed = true;

      // Recompute the authoritative product price after either side changes.
      if (changed) notifyPricing();
    }

    function uploadForSide(side) {
      for (var i = 0; i < uploadWraps.length; i++) {
        if ((uploadWraps[i].dataset.side || '') === side) return uploadWraps[i];
      }
      return side === 'front' ? (uploadWraps[0] || null) : (uploadWraps[1] || null);
    }

    function uploadFile(c) {
      var found = null;
      if (!c || !c.upload) return null;
      c.upload.querySelectorAll('.px-upinput').forEach(function (inp) {
        if (!found && inp.files && inp.files.length) found = inp.files[0];
      });
      return found;
    }

    function clearUploadForCard(c) {
      if (!c || !c.upload) return;
      c.upload.querySelectorAll('.px-upinput').forEach(function (inp) {
        if (inp.files && inp.files.length) inp.value = '';
      });
      c.upload.querySelectorAll('.px-uplist').forEach(function (lst) { lst.innerHTML = ''; });
      clearObjectUrl(c);
    }

    function fileIsPreviewable(file) {
      if (!file) return false;
      if (file.type && file.type.indexOf('image/') === 0) return true;
      return /\.(jpe?g|png|gif|webp|bmp|tiff?|svg|avif)$/i.test(file.name || '');
    }

    function objectUrlFor(c, file) {
      if (!c || !file || !fileIsPreviewable(file)) return null;
      var key = file.name + ':' + file.size + ':' + file.lastModified;
      var current = objectUrls[c.side];
      if (current && current.key === key) return current.url;
      if (current && current.url) {
        try { URL.revokeObjectURL(current.url); } catch (e) {}
      }
      var url = URL.createObjectURL(file);
      objectUrls[c.side] = { key: key, url: url };
      return url;
    }

    function clearObjectUrl(c) {
      if (!c) return;
      var current = objectUrls[c.side];
      if (!current) return;
      try { URL.revokeObjectURL(current.url); } catch (e) {}
      delete objectUrls[c.side];
    }

    function catalogueSelectEl() {
      return designWrap ? designWrap.querySelector('#px-design-catalog') : null;
    }

    function emptyCatalogueState(catalog) {
      return { code: '', name: '', image: '', price: 0, catalog: catalog || '' };
    }

    function catalogueInfoFromRadio(radio) {
      if (!radio) return emptyCatalogueState('');
      var tile = radio.closest ? radio.closest('.px-dtile') : null;
      var img = tile ? tile.querySelector('.px-dimg') : null;
      var designPanel = radio.closest ? radio.closest('.px-design-panel') : null;
      return {
        code: radio.value || '',
        name: radio.dataset.name || L.catalog,
        image: img ? (img.getAttribute('src') || img.dataset.full || '') : '',
        price: parseFloat(radio.dataset.price || '0') || 0,
        catalog: designPanel ? (designPanel.dataset.catalog || '') : ''
      };
    }

    function saveCatalogue(side, radio) {
      if (!side || !radio) return;
      sideState[side].catalog = catalogueInfoFromRadio(radio);
      sideState[side].mode = 'catalog';
      publishState();
    }

    function firstCatalogueRadioForCurrentCategory() {
      if (!designWrap) return null;
      var select = catalogueSelectEl();
      var wanted = select ? select.value : '';
      var panel = null;
      if (wanted) panel = designWrap.querySelector('.px-design-panel[data-catalog="' + wanted + '"]');
      if (!panel) panel = designWrap.querySelector('.px-design-panel.px-active-panel');
      if (!panel) panel = designWrap.querySelector('.px-design-panel');
      return panel ? panel.querySelector('input[type="radio"]') : null;
    }

    function ensureCatalogueForSide(side) {
      if (!side || !hasCatalog) return false;
      var saved = stateFor(side).catalog || emptyCatalogueState('');
      if (saved.code) return true;
      var radio = firstCatalogueRadioForCurrentCategory();
      if (!radio) return false;
      radio.checked = true;
      saveCatalogue(side, radio);
      return true;
    }

    function showCatalogueCategory(value) {
      if (!designWrap || !value) return;
      var sel = catalogueSelectEl();
      if (sel && sel.value !== value) {
        sel.value = value;
        sel.dispatchEvent(new Event('change', { bubbles: true }));
      }
      designWrap.querySelectorAll('.px-design-panel').forEach(function (p) {
        p.classList.toggle('px-active-panel', p.dataset.catalog === value);
      });
    }

    function restoreCatalogueForSide(side, notifyCore) {
      if (!designWrap || !side) return;
      var saved = stateFor(side).catalog || emptyCatalogueState('');
      var radios = Array.prototype.slice.call(designWrap.querySelectorAll('.px-design-panel input[type="radio"]'));
      var chosen = null;

      applyingSharedState = true;
      try {
        if (saved.catalog) showCatalogueCategory(saved.catalog);
        radios.forEach(function (r) { r.checked = false; });
        if (saved.code) {
          for (var i = 0; i < radios.length; i++) {
            var r = radios[i];
            var rp = r.closest ? r.closest('.px-design-panel') : null;
            if (r.value === saved.code && (!saved.catalog || (rp && rp.dataset.catalog === saved.catalog))) {
              chosen = r;
              break;
            }
          }
          if (chosen) chosen.checked = true;
        }
        if (notifyCore) {
          if (chosen) chosen.dispatchEvent(new Event('change', { bubbles: true }));
          else if (designToggle) designToggle.dispatchEvent(new Event('change', { bubbles: true }));
        }
      } finally {
        applyingSharedState = false;
      }
    }

    // Runtime-only visual rules for dualFabric. The base pxhw styles still come
    // from primex-textile-cards.css, so Messesystem and dualFabric stay aligned.
    // v15.1 visual-only border fix: the dualFabric cards must have ONE outer
    // border only, matching the Messesystem cards. Remove the old inset green
    // shadow/internal separators and clip child backgrounds to the card so the
    // active green border remains visible on all four sides, including bottom.
    var dualStyleId = 'px-tc-dual-unified-style-v15';
    if (!document.getElementById(dualStyleId)) {
      var dualStyle = document.createElement('style');
      dualStyle.id = dualStyleId;
      dualStyle.textContent =
        '#px-textile-section.pxhw-enhanced{--pxhw-ink:#171717;--pxhw-muted:#747474;--pxhw-line:#e2e2e2;--pxhw-soft:#f7f7f7;--pxhw-green:#24a849;--pxhw-green-soft:#eef9f0;--pxhw-red:#cb181b;}' +
        '#px-textile-section .px-tc-dual-shell{margin:2px 0 14px!important;}' +
        '#px-textile-section .px-tc-dual-track{gap:10px!important;align-items:flex-start!important;transform:none!important;overflow:visible!important;}' +
        '#px-textile-section .px-tc-dual-card{flex:0 0 calc((100% - 10px)/2)!important;border:1px solid #dedede!important;box-shadow:none!important;background:#fff!important;position:relative!important;overflow:hidden!important;box-sizing:border-box!important;}' +
        '#px-textile-section .px-tc-dual-card.is-active{border-color:#22a84a!important;box-shadow:none!important;z-index:2!important;}' +
        '#px-textile-section .px-tc-dual-card .pxhw-card-head{min-height:36px!important;padding:6px 9px!important;gap:7px!important;border:0!important;border-bottom:0!important;box-shadow:none!important;background:#fff!important;}' +
        '#px-textile-section .px-tc-dual-card .pxhw-card-head strong{font-size:12px!important;line-height:1.25!important;font-weight:700!important;}' +
        '#px-textile-section .px-tc-dual-card .pxhw-card-number{width:22px!important;height:22px!important;font-size:10.5px!important;}' +
        '#px-textile-section .px-tc-dual-card .pxhw-active-badge{padding:2px 6px!important;font-size:9px!important;text-transform:uppercase!important;}' +
        '#px-textile-section .px-tc-dual-card .pxhw-card-summary{min-height:54px!important;padding:6px 9px 7px!important;gap:7px!important;border:0!important;border-top:0!important;box-shadow:none!important;}' +
        '#px-textile-section .px-tc-dual-card .pxhw-thumb{width:42px!important;height:42px!important;}' +
        '#px-textile-section .px-tc-dual-card .pxhw-thumb-placeholder svg{width:19px!important;height:19px!important;}' +
        '#px-textile-section .px-tc-dual-card .pxhw-status-check{width:12px!important;height:12px!important;}' +
        '#px-textile-section .px-tc-dual-card .pxhw-status-text{font-size:11px!important;}' +
        '#px-textile-section .px-tc-dual-card .pxhw-file-hint,#px-textile-section .px-tc-dual-card .pxhw-fabric-hint{display:block;margin-top:1px!important;font-size:9px!important;color:#8a8a8a;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;}' +
        '#px-textile-section .px-tc-dual-card .pxhw-fabric-hint{margin-top:2px!important;color:#6f6f6f;}' +
        '#px-textile-section .px-tc-dual-card .pxhw-card-next{width:16px!important;height:16px!important;transition:transform .16s ease!important;}' +
        '#px-textile-section .px-tc-dual-card .pxhw-card-next svg{width:14px!important;height:14px!important;}' +
        '#px-textile-section .px-tc-dual-card.is-fabric-open .pxhw-card-next{transform:rotate(90deg)!important;}' +
        '#px-textile-section .px-tc-dual-card .pxhw-fabric-toggle{display:none!important;}' +
        '#px-textile-section .px-tc-dual-card .pxhw-fabric-panel{padding:9px 9px 10px!important;border:0!important;border-top:0!important;box-shadow:none!important;background:#fff!important;}' +
        '#px-textile-section .px-tc-dual-card .pxhw-fabric-panel-label{display:block!important;margin:0 0 5px!important;color:#686868!important;font-size:10.5px!important;font-weight:600!important;}' +
        '#px-textile-section .px-tc-dual-card .pxhw-fabric-option{min-height:27px!important;padding:3px 3px!important;gap:7px!important;border-top:0!important;font-size:10.5px!important;}' +
        '#px-textile-section .px-tc-dual-card .pxhw-radio{width:13px!important;height:13px!important;}' +
        '#px-textile-section .px-tc-dual-card .pxhw-fabric-option.is-selected .pxhw-radio::after{inset:3px!important;}' +
        '#px-textile-section .px-tc-dual-card .pxhw-recommended{display:none!important;}' +
        '#px-textile-section .px-tc-dual-card .pxhw-recommended-icon{width:14px!important;height:14px!important;min-width:14px!important;max-width:14px!important;max-height:14px!important;flex:none;margin-left:auto;object-fit:contain;display:block;}' +
        // v15.3: the base configurator CSS keeps .px-upload-wrap at display:none.
        // In dualFabric mode the core JS deliberately returns early and lets this
        // card UI own per-side visibility, so we must explicitly SHOW the active
        // side as well as hide the inactive side. Without these positive rules,
        // the mode button says 'Eigene Datei' but no upload zone is visible.
        '#px-textile-section .px-tc-dual-panel.px-tc-mode-upload[data-active-side="front"] .px-upload-wrap[data-side="front"],#px-textile-section .px-tc-dual-panel.px-tc-mode-upload[data-active-side="back"] .px-upload-wrap[data-side="back"]{display:block!important;}' +
        '#px-textile-section .px-tc-dual-panel.px-tc-mode-upload[data-active-side="front"] .px-upload-wrap[data-side="back"],#px-textile-section .px-tc-dual-panel.px-tc-mode-upload[data-active-side="back"] .px-upload-wrap[data-side="front"]{display:none!important;}' +
        '#px-textile-section .px-tc-dual-panel.px-tc-mode-upload #px-design-wrap{display:none!important;}' +
        '#px-textile-section .px-tc-dual-panel.px-tc-mode-catalog .px-upload-wrap{display:none!important;}' +
        '#px-textile-section .px-tc-dual-panel.px-tc-mode-catalog #px-design-wrap,#px-textile-section .px-tc-dual-panel.px-tc-mode-catalog #px-design-area{display:block!important;}' +
        '#px-textile-section .px-tc-dual-panel.px-tc-mode-unprinted .px-upload-wrap,#px-textile-section .px-tc-dual-panel.px-tc-mode-unprinted #px-design-wrap{display:none!important;}' +
        '@media(max-width:749px){#px-textile-section .px-tc-dual-card{flex-basis:100%!important;}#px-textile-section .px-tc-dual-track{gap:8px!important;}}';
      document.head.appendChild(dualStyle);
    }

    var shell = document.createElement('div');
    shell.className = 'pxhw-shell px-tc-dual-shell';
    shell.innerHTML = '<div class="pxhw-slider"><div class="pxhw-viewport"><div class="pxhw-track px-tc-dual-track"></div></div></div>';
    var track = shell.querySelector('.px-tc-dual-track');

    function ensureDualAvailableFabric(select, notify) {
      if (!select || !select.options || !select.options.length) return false;
      var current = select.selectedIndex >= 0 ? select.options[select.selectedIndex] : null;
      if (current && !current.disabled) return false;
      for (var i = 0; i < select.options.length; i++) {
        if (!select.options[i].disabled) {
          select.selectedIndex = i;
          if (notify !== false) select.dispatchEvent(new Event('change', { bubbles: true }));
          return true;
        }
      }
      select.selectedIndex = -1;
      return false;
    }

    function buildFabricOptions(c) {
      ensureDualAvailableFabric(c.select, true);
      var html = '';
      Array.prototype.forEach.call(c.select.options, function (opt, optionIndex) {
        var title = opt.dataset.title || opt.textContent;
        html +=
          '<button type="button" class="pxhw-fabric-option" data-index="' + optionIndex + '"' + (opt.disabled ? ' disabled' : '') + '>' +
            '<span class="pxhw-radio" aria-hidden="true"></span>' +
            '<span class="pxhw-fabric-name">' + esc(title) + '</span>' +
            (optionIndex === 0 ? '<img class="pxhw-recommended-icon" src="' + recommendedIcon + '" alt="' + esc(L.recommended) + '" title="' + esc(L.recommended) + '">' : '') +
          '</button>';
      });
      return html;
    }

    sideDefs.forEach(function (def) {
      var c = { index: def.index, side: def.side, select: def.select, upload: uploadForSide(def.side), card: null };
      var card = document.createElement('article');
      card.className = 'pxhw-card px-tc-dual-card';
      card.dataset.tcSide = def.side;
      card.innerHTML =
        '<div class="pxhw-card-head">' +
          '<span class="pxhw-card-number">' + (def.index + 1) + '</span>' +
          '<strong>' + esc(def.title) + '</strong>' +
          '<span class="pxhw-active-badge">' + esc(L.active) + '</span>' +
        '</div>' +
        '<button type="button" class="pxhw-card-summary" aria-label="' + esc(def.title) + '">' +
          '<span class="pxhw-thumb"><span class="pxhw-thumb-placeholder">' + NOIMG_SVG + '</span><img alt="" hidden></span>' +
          '<span class="pxhw-summary-copy">' +
            '<span class="pxhw-summary-line"><span class="pxhw-status-check">' + CHECK_SVG + '</span><span class="pxhw-status-text"></span></span>' +
            '<small class="pxhw-file-hint"></small>' +
            '<small class="pxhw-fabric-hint"></small>' +
          '</span>' +
          '<span class="pxhw-card-next">' + CHEVRON_SVG + '</span>' +
        '</button>' +
        '<button type="button" class="pxhw-fabric-toggle" aria-expanded="false"><span>' + esc(L.chooseFabric) + '</span></button>' +
        '<div class="pxhw-fabric-panel" hidden><div class="pxhw-fabric-panel-label">' + esc(L.chooseFabric) + '</div></div>';
      c.card = card;
      card.querySelector('.pxhw-fabric-panel').insertAdjacentHTML('beforeend', buildFabricOptions(c));
      c.select.classList.add('px-hwc-hidden-select');
      card.appendChild(c.select);

      var infoBtn = root.querySelector('.px-info-btn[data-for="' + def.infoFor + '"]');
      if (infoBtn) card.querySelector('.pxhw-card-head').appendChild(infoBtn);
      if (def.labelEl) def.labelEl.style.display = 'none';

      track.appendChild(card);
      cards.push(c);
    });

    var firstAnchor = sideDefs[0].labelEl || fabricSelect;
    firstAnchor.parentNode.insertBefore(shell, firstAnchor);

    function selectedFabricTitle(c) {
      if (!c || !c.select || c.select.selectedIndex < 0) return '';
      var opt = c.select.options[c.select.selectedIndex];
      return opt ? (opt.dataset.title || opt.textContent || '') : '';
    }

    function syncCardFabric(c) {
      var buttons = c.card.querySelectorAll('.pxhw-fabric-option');
      Array.prototype.forEach.call(c.select.options, function (opt, i) {
        var button = buttons[i];
        if (!button) return;
        var disabled = !!opt.disabled;
        button.disabled = disabled;
        button.classList.toggle('is-selected', c.select.selectedIndex === i);
        button.setAttribute('aria-pressed', c.select.selectedIndex === i ? 'true' : 'false');
        var icon = button.querySelector('.pxhw-recommended-icon');
        if (icon) icon.style.display = disabled ? 'none' : '';
      });
    }

    function closeFabricPanels(except) {
      cards.forEach(function (c) {
        if (c === except) return;
        var p = c.card.querySelector('.pxhw-fabric-panel');
        if (p) p.setAttribute('hidden', '');
        c.card.classList.remove('is-fabric-open');
      });
    }

    function setThumb(c, src, placeholderIcon) {
      var img = c.card.querySelector('.pxhw-thumb img');
      var placeholder = c.card.querySelector('.pxhw-thumb-placeholder');
      if (src) {
        img.src = src;
        img.hidden = false;
        placeholder.hidden = true;
      } else {
        img.hidden = true;
        img.removeAttribute('src');
        placeholder.hidden = false;
        placeholder.innerHTML = placeholderIcon || NOIMG_SVG;
      }
    }

    function notifyPreview() {
      var active = cards[activeIndex];
      var mode = active ? modeFor(active.side) : 'upload';
      root.dataset.pxActiveTextileSlot = String(activeIndex + 1);
      try {
        root.dispatchEvent(new CustomEvent('px:textile-preview-change', {
          bubbles: true,
          detail: { slot: activeIndex + 1, side: active ? active.side : 'front', mode: mode }
        }));
      } catch (e) {}
    }

    function refreshDualFaces() {
      cards.forEach(function (c, i) {
        var st = stateFor(c.side);
        var mode = modeFor(c.side);
        var cat = st.catalog || emptyCatalogueState('');
        var active = i === activeIndex;
        var statusEl = c.card.querySelector('.pxhw-status-text');
        var hintEl = c.card.querySelector('.pxhw-file-hint');
        var fabricHintEl = c.card.querySelector('.pxhw-fabric-hint');
        var badge = c.card.querySelector('.pxhw-active-badge');
        var file = uploadFile(c);
        var status = '';
        var hint = '';
        var fabricHint = selectedFabricTitle(c);
        var src = '';
        var placeholderIcon = NOIMG_SVG;

        c.card.classList.toggle('is-active', active);
        c.card.classList.add('is-complete');
        if (badge) badge.style.display = active ? '' : 'none';

        if (mode === 'catalog') {
          status = L.catalog;
          hint = cat.name || L.noFileYet;
          src = cat.image || '';
          placeholderIcon = CATALOG_ICON;
          clearObjectUrl(c);
        } else if (mode === 'unprinted') {
          status = L.unprinted;
          hint = fabricHint;
          fabricHint = '';
          placeholderIcon = UNPRINTED_ICON;
          clearObjectUrl(c);
        } else {
          status = L.upload;
          hint = file ? file.name : noFileText;
          if (file && fileIsPreviewable(file)) src = objectUrlFor(c, file) || '';
          else {
            clearObjectUrl(c);
            placeholderIcon = UPLOAD_ICON;
          }
        }

        if (statusEl) statusEl.textContent = status;
        if (hintEl) hintEl.textContent = hint;
        if (fabricHintEl) {
          fabricHintEl.textContent = fabricHint;
          fabricHintEl.hidden = !fabricHint;
        }
        setThumb(c, src, placeholderIcon);
        syncCardFabric(c);
      });
      publishState();
      notifyPreview();
    }

    function updateModeEditorForActive() {
      if (!panel || !modeRow) return;
      var active = cards[activeIndex];
      if (!active) return;
      var mode = modeFor(active.side);
      panel.dataset.activeSide = active.side;
      modeRow.querySelectorAll('[data-tc-mode]').forEach(function (b) {
        b.classList.toggle('px-active', b.dataset.tcMode === mode);
      });
      panel.classList.remove('px-tc-mode-upload', 'px-tc-mode-catalog', 'px-tc-mode-unprinted');
      panel.classList.add('px-tc-mode-' + mode);

      applyingSharedState = true;
      try {
        if (mode === 'unprinted') {
          if (printNoBtn && !printNoBtn.classList.contains('px-active')) printNoBtn.click();
          if (designToggle && designToggle.checked) {
            designToggle.checked = false;
            designToggle.dispatchEvent(new Event('change', { bubbles: true }));
          }
        } else {
          if (printYesBtn && !printYesBtn.classList.contains('px-active')) printYesBtn.click();
          if (mode === 'catalog') {
            if (designToggle && !designToggle.checked) {
              designToggle.checked = true;
              designToggle.dispatchEvent(new Event('change', { bubbles: true }));
            }
            // Entering catalogue mode is immediately a valid, priced choice:
            // if this side has no saved motif yet, take the first motif from
            // the currently selected catalogue and show it in the card.
            ensureCatalogueForSide(active.side);
            restoreCatalogueForSide(active.side, true);
          } else if (designToggle && designToggle.checked) {
            designToggle.checked = false;
            designToggle.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
      } finally {
        applyingSharedState = false;
      }
    }

    function activateCard(index, openFabric) {
      activeIndex = index;
      var target = cards[index];
      closeFabricPanels(target);
      cards.forEach(function (c, i) {
        var fabricPanel = c.card.querySelector('.pxhw-fabric-panel');
        if (i !== index && fabricPanel) fabricPanel.setAttribute('hidden', '');
        if (i !== index) c.card.classList.remove('is-fabric-open');
      });
      if (target) {
        var p = target.card.querySelector('.pxhw-fabric-panel');
        if (openFabric && p) {
          p.removeAttribute('hidden');
          target.card.classList.add('is-fabric-open');
        } else if (p) {
          p.setAttribute('hidden', '');
          target.card.classList.remove('is-fabric-open');
        }
      }
      updateModeEditorForActive();
      refreshDualFaces();
    }

    cards.forEach(function (c, index) {
      var summary = c.card.querySelector('.pxhw-card-summary');
      var fabricPanel = c.card.querySelector('.pxhw-fabric-panel');
      summary.addEventListener('click', function () {
        var wasOpen = fabricPanel && !fabricPanel.hasAttribute('hidden');
        activateCard(index, !wasOpen);
      });

      c.card.querySelectorAll('.pxhw-fabric-option').forEach(function (button) {
        button.addEventListener('click', function () {
          if (button.disabled) return;
          var optionIndex = parseInt(button.dataset.index, 10);
          if (!isFinite(optionIndex) || !c.select.options[optionIndex] || c.select.options[optionIndex].disabled) return;
          c.select.selectedIndex = optionIndex;
          c.select.dispatchEvent(new Event('change', { bubbles: true }));
          if (fabricPanel) fabricPanel.setAttribute('hidden', '');
          c.card.classList.remove('is-fabric-open');
          activeIndex = index;
          updateModeEditorForActive();
          refreshDualFaces();
        });
      });

      c.select.addEventListener('change', function () {
        syncCardFabric(c);
        refreshDualFaces();
      });
      syncCardFabric(c);

      if ('MutationObserver' in window) {
        new MutationObserver(function () {
          syncCardFabric(c);
          refreshDualFaces();
        }).observe(c.select, { subtree: true, attributes: true, attributeFilter: ['disabled'] });
      }

      if (c.upload) {
        c.upload.querySelectorAll('.px-upinput').forEach(function (inp) {
          inp.addEventListener('change', function () {
            sideState[c.side].mode = 'upload';
            activeIndex = index;
            publishState();
            updateModeEditorForActive();
            refreshDualFaces();
          });
        });
      }
    });

    if (uploadWraps.length || hasCatalog || hasUnprinted) {
      panel = document.createElement('div');
      panel.className = 'px-hwc-mode-panel px-tc-panel px-tc-dual-panel';
      panel.dataset.activeSide = 'front';
      panel.innerHTML =
        '<div class="px-hwc-mode-heading">' + L.modeHeading + '</div>' +
        '<div class="px-hwc-mode-row"></div>' +
        '<div class="px-hwc-mode-content"></div>';
      modeRow = panel.querySelector('.px-hwc-mode-row');
      modeContent = panel.querySelector('.px-hwc-mode-content');

      var modeDefs = [];
      if (uploadWraps.length) modeDefs.push({ key: 'upload', label: L.upload, icon: UPLOAD_ICON });
      if (hasCatalog) modeDefs.push({ key: 'catalog', label: L.catalog, icon: CATALOG_ICON });
      if (hasUnprinted) modeDefs.push({ key: 'unprinted', label: L.unprinted, icon: UNPRINTED_ICON });
      modeRow.innerHTML = modeDefs.map(function (m) {
        return '<button type="button" class="px-hwc-mode-btn" data-tc-mode="' + m.key + '">' + m.icon + '<span>' + m.label + '</span></button>';
      }).join('');

      uploadWraps.forEach(function (w) { modeContent.appendChild(w); });
      if (designWrap) modeContent.appendChild(designWrap);
      shell.parentNode.insertBefore(panel, shell.nextSibling);

      modeRow.querySelectorAll('[data-tc-mode]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var active = cards[activeIndex];
          if (!active) return;
          sideState[active.side].mode = btn.dataset.tcMode;
          if (btn.dataset.tcMode !== 'upload') clearUploadForCard(active);
          publishState();
          updateModeEditorForActive();
          refreshDualFaces();
          // Guarantee a pricing/cart refresh even when the underlying global
          // print button was already in the same state.
          if (btn.dataset.tcMode === 'unprinted') {
            if (printNoBtn) printNoBtn.click();
          } else if (printYesBtn) {
            printYesBtn.click();
          }
        });
      });
    }

    if (designWrap) {
      // Capture tile clicks BEFORE the core image click handler. The core used
      // to set radio.checked programmatically without emitting "change", which
      // is why the card never learned which motif the customer clicked.
      designWrap.querySelectorAll('.px-dtile').forEach(function (tile) {
        tile.addEventListener('click', function () {
          if (applyingSharedState) return;
          var active = cards[activeIndex];
          if (!active || modeFor(active.side) !== 'catalog') return;
          var radio = tile.querySelector('input[type="radio"]');
          if (!radio) return;
          radio.checked = true;
          saveCatalogue(active.side, radio);
          radio.dispatchEvent(new Event('change', { bubbles: true }));
          refreshDualFaces();
        }, true);
      });

      designWrap.querySelectorAll('.px-design-panel input[type="radio"]').forEach(function (r) {
        r.addEventListener('change', function () {
          if (applyingSharedState) return;
          var active = cards[activeIndex];
          if (!active || modeFor(active.side) !== 'catalog') return;
          saveCatalogue(active.side, r);
          refreshDualFaces();
        });
      });

      var dualCatalogSelect = catalogueSelectEl();
      if (dualCatalogSelect) {
        dualCatalogSelect.addEventListener('change', function () {
          if (applyingSharedState) return;
          var active = cards[activeIndex];
          if (!active || modeFor(active.side) !== 'catalog') return;
          // Changing catalogue category must never leave a catalogue card in an
          // unpriced/empty state. Select the first motif of the new category.
          sideState[active.side].catalog = emptyCatalogueState(dualCatalogSelect.value || '');
          var firstRadio = firstCatalogueRadioForCurrentCategory();
          if (firstRadio) {
            firstRadio.checked = true;
            saveCatalogue(active.side, firstRadio);
            firstRadio.dispatchEvent(new Event('change', { bubbles: true }));
          } else {
            publishState();
          }
          refreshDualFaces();
        });
      }
    }

    // Preserve an existing browser-restored catalogue choice as FRONT only;
    // never leak it automatically to the back side.
    if (initialMode === 'catalog' && designWrap) {
      var initialChecked = designWrap.querySelector('.px-design-panel.px-active-panel input[type="radio"]:checked');
      if (initialChecked) saveCatalogue('front', initialChecked);
    }

    publishState();
    // Keep card 1 active for the shared artwork editor, but keep its fabric
    // accordion closed on first load. Both native selects already carry the
    // first available valid fabric.
    activateCard(0, false);
    refreshDualFaces();

    window.addEventListener('beforeunload', function () {
      cards.forEach(clearObjectUrl);
    });
  }

  if (isDualFabric) {
    initDualFabric();
    return;
  }

  function fabricLabel() {
    var t = root.querySelector('[data-i18n="textileType"], [data-i18n="textileTypeFront"]');
    return (t && t.textContent.trim()) || L.textileTitle;
  }

  // v1.2: The pricing engine remains the single source of truth for fabric
  // availability. primex-configurator.js applies each fabric's data-maxw and
  // the Formula JSON flag ignoreFabricWidthLimit by setting the REAL <option>
  // elements disabled/enabled. This visual card UI must mirror that state; it
  // must never calculate width limits itself.
  function syncFabricRows() {
    if (!fabricSelect || !fabricList) return;

    var rows = fabricList.querySelectorAll('.px-hwc-fabric-row');
    Array.prototype.forEach.call(fabricSelect.options, function (opt, i) {
      var row = rows[i];
      if (!row) return;

      var radio = row.querySelector('input[type="radio"]');
      if (!radio) return;

      var disabled = !!opt.disabled;
      radio.disabled = disabled;
      radio.checked = fabricSelect.selectedIndex === i;

      row.classList.toggle('is-disabled', disabled);
      row.setAttribute('aria-disabled', disabled ? 'true' : 'false');
      row.style.opacity = disabled ? '0.45' : '';
      row.style.cursor = disabled ? 'not-allowed' : '';

      // Do not visually recommend a fabric that the pricing engine says is
      // unavailable for the customer's current dimensions.
      var thumb = row.querySelector('.px-hwc-fabric-thumb');
      if (thumb) thumb.style.display = disabled ? 'none' : '';
    });
  }

  // ---- build the single card (fabric list only) ----
  var card = null, fabricList = null;
  if (fabricSelect && fabricSelect.options.length) {
    // A single-card product starts with a valid fabric already selected, but
    // its fabric list stays closed until the customer opens the card.
    (function ensureSingleAvailableFabric() {
      var current = fabricSelect.selectedIndex >= 0 ? fabricSelect.options[fabricSelect.selectedIndex] : null;
      if (current && !current.disabled) return;
      for (var first = 0; first < fabricSelect.options.length; first++) {
        if (!fabricSelect.options[first].disabled) {
          fabricSelect.selectedIndex = first;
          fabricSelect.dispatchEvent(new Event('change', { bubbles: true }));
          return;
        }
      }
      fabricSelect.selectedIndex = -1;
    })();
    card = document.createElement('div');
    card.className = 'px-hwc-card px-tc-card px-tc-single';
    card.innerHTML =
      '<button type="button" class="px-hwc-face">' +
        '<span class="px-hwc-face-top">' +
          '<span class="px-hwc-title">' + fabricLabel() + '</span>' +
          '<span class="px-hwc-active-badge">' + L.active + '</span>' +
        '</span>' +
        '<span class="px-hwc-face-bottom">' +
          '<span class="px-hwc-status" data-tc-status>' + CHECK_SVG + '<span data-tc-status-text></span></span>' +
          '<span class="px-hwc-chevron">' + CHEVRON_SVG + '</span>' +
        '</span>' +
      '</button>' +
      '<div class="px-hwc-body" data-tc-body style="display:none"></div>';
    var body = card.querySelector('[data-tc-body]');

    function closeSingleFabricCard() {
      body.style.display = 'none';
      card.classList.remove('is-expanded');
    }
    fabricSelect.classList.add('px-hwc-hidden-select');
    var fabricWrap = document.createElement('div');
    fabricWrap.className = 'px-hwc-fabric-wrap';
    fabricWrap.innerHTML = '<div class="px-hwc-fabric-label">' + L.chooseFabric + '</div>';
    var list = document.createElement('div');
    list.className = 'px-hwc-fabric-list';
    Array.prototype.forEach.call(fabricSelect.options, function (opt, i) {
      var row = document.createElement('label');
      row.className = 'px-hwc-fabric-row';
      var title = opt.dataset.title || opt.textContent;
      row.innerHTML =
        '<input type="radio" name="px-tc-fabric" ' + (opt.selected ? 'checked' : '') + '>' +
        '<span class="px-hwc-fabric-circle"></span>' +
        '<span class="px-hwc-fabric-name" title="' + title.replace(/"/g, '&quot;') + '">' + title + '</span>' +
        (i === 0 ? '<img class="px-hwc-fabric-thumb" src="https://cdn.shopify.com/s/files/1/0643/3469/2616/files/thumbs_up_green.svg?v=1787828479" alt="' + L.recommended + '" title="' + L.recommended + '">' : '');
      var radio = row.querySelector('input');
      radio.addEventListener('change', function () {
        // A disabled native option is authoritative. This protects against a
        // stale/clicked visual row and prevents an invalid fabric from ever
        // being pushed back into the real select.
        if (opt.disabled) {
          syncFabricRows();
          return;
        }
        fabricSelect.selectedIndex = i;
        fabricSelect.dispatchEvent(new Event('change', { bubbles: true }));
        syncFabricRows();
        refreshFace();
        closeSingleFabricCard();
      });
      // Clicking the already-selected fabric does not fire a radio change in
      // every browser. Still close the accordion so the behavior is identical
      // for first selection, reselection and all other card types.
      row.addEventListener('click', function () {
        if (!opt.disabled) window.setTimeout(closeSingleFabricCard, 0);
      });
      list.appendChild(row);
    });
    fabricWrap.appendChild(list);
    body.appendChild(fabricWrap);
    // Info-tooltip button, if this fabric field has one, stays reachable —
    // moved to sit right under the card title rather than removed.
    var infoBtn = root.querySelector('.px-info-btn[data-for="px-fabric-select"]');
    if (infoBtn) card.querySelector('.px-hwc-face-top').appendChild(infoBtn);
    fabricSelect.parentNode.insertBefore(card, fabricSelect);
    body.appendChild(fabricSelect);
    fabricList = list;

    // Initial sync is important because primex-configurator.js executes first
    // (defer order) and may already have disabled fabrics for the initial size.
    syncFabricRows();

    // User/card changes dispatch a real change event on the native select; keep
    // the visual radios aligned with whichever option the pricing engine accepts.
    fabricSelect.addEventListener('change', function () {
      syncFabricRows();
      // A completed fabric choice is represented by the closed summary card.
      closeSingleFabricCard();
    });

    // Width/height/depth changes do NOT dispatch a select change when the core
    // auto-switches away from an invalid fabric. The core does, however, change
    // option.disabled. Observe exactly that native state so the card mirrors it
    // after every compute(), including ignoreFabricWidthLimit=true products.
    if ('MutationObserver' in window) {
      var fabricAvailabilityObserver = new MutationObserver(function () {
        syncFabricRows();
      });
      fabricAvailabilityObserver.observe(fabricSelect, {
        subtree: true,
        attributes: true,
        attributeFilter: ['disabled']
      });
    }
  }

  // ---- shared "Art der Gestaltung wählen" panel ----
  var hasCatalog = !!designWrap;
  var hasUnprinted = !!(printYesBtn && printNoBtn);
  var needsPanel = uploadWraps.length || hasCatalog || hasUnprinted;
  var panel = null, modeRowEl = null, modeContentEl = null;
  if (needsPanel) {
    panel = document.createElement('div');
    panel.className = 'px-hwc-mode-panel px-tc-panel';
    panel.innerHTML =
      '<div class="px-hwc-mode-heading">' + L.modeHeading + '</div>' +
      '<div class="px-hwc-mode-row"></div>' +
      '<div class="px-hwc-mode-content"></div>';
    modeRowEl = panel.querySelector('.px-hwc-mode-row');
    modeContentEl = panel.querySelector('.px-hwc-mode-content');

    var modeBtns = [];
    if (uploadWraps.length) modeBtns.push({ key: 'upload', label: L.upload, icon: UPLOAD_ICON });
    if (hasCatalog) modeBtns.push({ key: 'catalog', label: L.catalog, icon: CATALOG_ICON });
    if (hasUnprinted) modeBtns.push({ key: 'unprinted', label: L.unprinted, icon: UNPRINTED_ICON });
    modeRowEl.innerHTML = modeBtns.map(function (m) {
      return '<button type="button" class="px-hwc-mode-btn" data-tc-mode="' + m.key + '">' + m.icon + '<span>' + m.label + '</span></button>';
    }).join('');

    uploadWraps.forEach(function (w) { modeContentEl.appendChild(w); });
    if (designWrap) modeContentEl.appendChild(designWrap);

    function setMode(mode) {
      modeRowEl.querySelectorAll('[data-tc-mode]').forEach(function (b) {
        b.classList.toggle('px-active', b.dataset.tcMode === mode);
      });
      if (mode === 'unprinted') {
        if (printNoBtn && !printNoBtn.classList.contains('px-active')) printNoBtn.click();
      } else {
        if (printYesBtn && !printYesBtn.classList.contains('px-active')) printYesBtn.click();
        if (mode === 'catalog' && designToggle && !designToggle.checked) {
          designToggle.checked = true;
          designToggle.dispatchEvent(new Event('change', { bubbles: true }));
        }
        if (mode === 'catalog' && designWrap) {
          var activePanel = designWrap.querySelector('.px-design-panel.px-active-panel') || designWrap.querySelector('.px-design-panel');
          var checked = activePanel ? activePanel.querySelector('input[type="radio"]:checked') : null;
          if (!checked && activePanel) {
            checked = activePanel.querySelector('input[type="radio"]');
            if (checked) {
              checked.checked = true;
              checked.dispatchEvent(new Event('change', { bubbles: true }));
            }
          }
        } else if (mode === 'upload' && designToggle && designToggle.checked) {
          designToggle.checked = false;
          designToggle.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
      // v1.0 fix: primex-configurator.js's own updateTextileUI() re-sets
      // designWrap/uploadWraps' inline display on EVERY compute() cycle
      // (150ms debounced), purely based on printable/designOn — it knows
      // nothing about our 3-way mode and would silently undo a plain
      // inline-style hide shortly after we set it. Using a mode class with
      // !important CSS instead — the EXACT same technique
      // primex-ui-enhancements.js's initImageTabs() already uses safely
      // for this identical conflict — means our hide always wins,
      // regardless of what inline style the real engine re-applies.
      if (panel) {
        panel.classList.remove('px-tc-mode-upload', 'px-tc-mode-catalog', 'px-tc-mode-unprinted');
        panel.classList.add('px-tc-mode-' + mode);
      }
      refreshFace();
    }
    modeRowEl.querySelectorAll('[data-tc-mode]').forEach(function (btn) {
      btn.addEventListener('click', function () { setMode(btn.dataset.tcMode); });
    });

    // initial mode: whatever the page already loaded into (real state wins)
    var initialMode = 'upload';
    if (hasUnprinted && printNoBtn && printNoBtn.classList.contains('px-active')) initialMode = 'unprinted';
    else if (hasCatalog && designToggle && designToggle.checked) initialMode = 'catalog';
    setMode(initialMode);

    if (card) {
      card.parentNode.insertBefore(panel, card.nextSibling);
    } else if (section) {
      // AREA_FIX / motif-only products have no fabric card. At this point the
      // original upload/catalogue nodes have already been moved INTO `panel`,
      // so using one of them as the insertion anchor would try to insert the
      // panel into itself and throws HierarchyRequestError. Insert the completed
      // artwork panel back into #px-textile-section before print-data instead.
      var pdAnchor = section.querySelector('#px-pd-wrap');
      if (pdAnchor) section.insertBefore(panel, pdAnchor);
      else section.appendChild(panel);
    }
  }

  function refreshFace() {
    if (!card) return;
    var statusText = card.querySelector('[data-tc-status-text]');
    if (!statusText) return;
    var activeBtn = modeRowEl ? modeRowEl.querySelector('.px-hwc-mode-btn.px-active') : null;
    var mode = activeBtn ? activeBtn.dataset.tcMode : 'upload';
    var file = null;
    uploadWraps.forEach(function (w) {
      if (file) return;
      var inp = w.querySelector('.px-upinput');
      if (inp && inp.files && inp.files.length) file = inp.files[0];
    });
    var catChecked = designWrap ? designWrap.querySelector('.px-design-panel.px-active-panel input[type="radio"]:checked') : null;
    if (mode === 'upload' && file) statusText.textContent = file.name;
    else if (mode === 'catalog' && catChecked) statusText.textContent = catChecked.dataset.name || L.catalog;
    else if (mode === 'unprinted') statusText.textContent = L.unprinted;
    else {
      var selectedOpt = fabricSelect && fabricSelect.selectedIndex >= 0 ? fabricSelect.options[fabricSelect.selectedIndex] : null;
      statusText.textContent = selectedOpt ? (selectedOpt.dataset.title || selectedOpt.textContent || L.noFileYet) : L.noFileYet;
    }
  }
  uploadWraps.forEach(function (w) {
    w.querySelectorAll('.px-upinput').forEach(function (inp) { inp.addEventListener('change', refreshFace); });
  });
  if (designWrap) {
    designWrap.querySelectorAll('input[type="radio"]').forEach(function (r) {
      r.addEventListener('change', refreshFace);
    });
  }
  refreshFace();

  // accordion click on the single card just toggles emphasis (there's only
  // one card, so this is mostly cosmetic — expanding/collapsing the fabric
  // list without hiding anything pricing-relevant).
  if (card) {
    card.querySelector('.px-hwc-face').addEventListener('click', function () {
      var body = card.querySelector('[data-tc-body]');
      var open = body.style.display !== 'none';
      body.style.display = open ? 'none' : 'block';
      card.classList.toggle('is-expanded', !open);
    });
  }
})();